
import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {
  Action,
  Getter,
} from 'vuex-class';
import ImageSelector from '@/components/ImageSelector.vue';

@Component({
  components: {ImageSelector},
})
export default class DlgEventSendGuestEmail extends Vue {
  @Prop({type: Object, default: () => ({})}) public event!: any;
  @Prop({type: Object, default: () => ({})}) public guest!: any;
  @Prop({type: Boolean, default: false}) public value!: boolean;

  @Action('admin/events/sendGuestMail') private sendGuestMail!: any;

  @Getter('common/rules/all') private rules!: any;
  @Getter('admin/events/templates') private templates!: any;

  private loading: boolean = false;
  private selectedTemplate: string = '';
  private type: number = 1;

  private updated() {
    if (this.templates.length === 1) {
      this.selectedTemplate = this.templates[0].id;
    }
  }

  private selectTemplate(template) {
    if (this.loading) {
      return;
    }
    this.selectedTemplate = template.id;
  }

  get isTemplateSelected() {
    return this.selectedTemplate !== '' && this.type > 0;
  }

  get dialog() {
    return this.value;
  }

  set dialog(val) {
    this.$emit('input', val);
  }

  private async send() {
    this.loading = true;
    await this.sendGuestMail({eventId: this.event.id, templateId: this.selectedTemplate, guestId: this.guest.id});
    this.loading = false;
    this.selectedTemplate = '';
    this.dialog = false;
  }
}
